import { SET_PRIMARY_GRANULARITY, SET_SECONDARY_GRANULARITY, SET_CURRENT_DATES, RESET_DIGITAL_TWIN_STATE } from "../Redux/DigitalTwin/types";

export const setPrimaryGranularity = (granularity) => ({
    type: SET_PRIMARY_GRANULARITY,
    payload: granularity
});

export const setSecondaryGranularity = (granularity) => ({
    type: SET_SECONDARY_GRANULARITY,
    payload: granularity
});

export const setCurrentDatesForChart = (dates) => ({
    type: SET_CURRENT_DATES,
    payload: dates
});

export const resetDigitalTwinState = () => ({
    type: RESET_DIGITAL_TWIN_STATE
});

// Thunk action creator for handling granularity changes
export const updatePrimaryGranularity = (granularity) => (dispatch, getState) => {
    dispatch(setPrimaryGranularity(granularity));
    
    if (granularity === 'raw') {
        dispatch(setSecondaryGranularity('avg'));
    }
};

// Thunk action creator for handling date changes
export const updateCurrentDates = (dates) => (dispatch) => {
    dispatch(setCurrentDatesForChart(dates));
    dispatch(setPrimaryGranularity('raw'));
    dispatch(setSecondaryGranularity('avg'));
};